import {useLayoutEffect} from "react";

import CardTechnology from "../../components/cardTechnology";
import Footer from "../../components/footer";
import ContactForm from "../../components/forms";
import Gallery from "../../components/gallery";
import {GalleryItems} from "../../components/gallery/constants/galleryData";
import GoogleMaps from "../../components/googleMaps";
import Header from "../../components/header";
import Hero from "../../components/hero";
import Numbers from "../../components/numbers";
import Servicess from "../../components/Servicess";
import * as S from "./styles";

const techData = [
  {
    id: "ActivatedCarbon",
    title: "Activated Carbon",
    description: "High-efficiency air filtration for VOCs, H₂S, and odor removal.",
    link: "/carbon",
  },
  {
    id: "MistEliminators",
    title: "Brink® Mist Eliminators",
    description: "Efficient aerosol removal from gas streams—up to 99,95% efficiency.",
    link: "/brink",
  },
  {
    id: "GasScrubbers",
    title: "Gas Scrubbers",
    description: "Removes acid gases, VOCs, and odors with high efficiency.",
    link: "/gas",
  },
  {
    id: "MeshPad",
    title: "MeshPad",
    description: "Remove mist droplets with low pressure drop and simple operation.",
    link: "/meshpads",
  },
  {
    id: "SAP",
    title: "Sap product",
    description: "Complete solutions for sulphuric acid plants and emissions control.",
    link: "/sap",
  },
];

const galleryData = [
  {
    ...GalleryItems.AcidMistAndAerosols,
    description:
      "Targeted removal of fine acid droplets to protect people, equipment, and ensure cleaner emissions. ",
    link: "/acidfumes",
  },
  {
    ...GalleryItems.OrganicMistsEAerosols,
    description:
      "Smart solutions for capturing fine organic particles and reducing fire and environmental risks.",
    link: "/organic",
  },
  {
    ...GalleryItems.AcidFumes,
    description:
      "Reliable treatment of corrosive gases and inorganic pollutants from harsh process emissions.",
    link: "/acidfumes",
  },
  {
    ...GalleryItems.Desulphurisation,
    description:
      "Reduce SO₂ and other sulfur compounds efficiently across a wide range of gas streams.",
    link: "/desulphurisation",
  },
  {
    ...GalleryItems.VOC,
    description:
      "Proven systems for removing volatile compounds, unpleasant odors, and hazardous gases like H₂S.",
    link: "/vocodourcontrol",
  },
  {
    ...GalleryItems.OfGas,
    description:
      "End-to-end treatment of complex off-gas streams—engineered for compliance and performance.",
    link: "/offgastreatment",
  },
];

function Home() {
  useLayoutEffect(() => {
    const scrollToSectionFromHash = () => {
      const hash = window.location.hash;

      if (!hash) return;

      const id = hash.replace("#", "");
      const section = document.getElementById(id);

      if (section) {
        setTimeout(() => {
          section.scrollIntoView({behavior: "smooth", block: "start"});
        }, 0);
      }
    };

    scrollToSectionFromHash(); // Executa no carregamento

    window.addEventListener("hashchange", scrollToSectionFromHash);
    return () => window.removeEventListener("hashchange", scrollToSectionFromHash);
  }, []);

  return (
    <S.PageWrapper>
      <Header />
      <Hero />
      <S.CompaniesSection>
        <S.CompaniesText>Trusted by teams from leading companies</S.CompaniesText>
      </S.CompaniesSection>
      <S.SolutionsSection id="solutionsHome">
        <Gallery items={galleryData} />
      </S.SolutionsSection>
      <S.TechnologiesSubtitle>Our Technologies</S.TechnologiesSubtitle>
      <S.TechnologiesTitle>Start improving your environmental impact.</S.TechnologiesTitle>
      <S.TechnologiesIntroText>
        We collaborate with industry leaders such as MECS Global and Chemviron Carbons Ltd,
        Socrematic France, to create clean alternatives to traditional industrial processes and make
        the world a better place for all.
      </S.TechnologiesIntroText>
      <S.TechnologysSection id="technologiesHome">
        <CardTechnology data={techData} />
      </S.TechnologysSection>
      <S.ServicessSection id="servicesHome">
        <Servicess />
      </S.ServicessSection>

      <Numbers />

      {/* id="numbersHome" */}
      <S.ContactSection id="contactSection">
        <S.LeftContent>
          <ContactForm />

          <S.ContactInfo>
            <S.InfoBlock>
              <S.IconPhone />
              <span>Phone</span>
              <span>+31(0)72 8200 270</span>
            </S.InfoBlock>
            <S.InfoBlock>
              <S.IconEmail />
              <span>E-mail</span>
              <span>info@ecosystemseurope.com</span>
            </S.InfoBlock>
          </S.ContactInfo>
        </S.LeftContent>

        <S.RightContent>
          <S.TextBlock>
            <span className="highlight">Get in Touch</span>
            <h2>Let us help you achieve optimal performance and cleaner environment for all.</h2>
            <p>
              Don’t hesitate to contact us today to learn more about our services, products, and to
              request an expert visit.
            </p>
          </S.TextBlock>

          <S.MapWrapperWithBlock>
            <GoogleMaps />
          </S.MapWrapperWithBlock>
        </S.RightContent>
      </S.ContactSection>
      <Footer />
    </S.PageWrapper>
  );
}

export default Home;
